import { fetch } from '../request';
import type { IResponse, RequestConfig } from '../interface';
import type { ChengPianDetail, Opus } from '../interface/space';

/**
 * 获取个人空间作品、成片模板列表
 * @param params
 * @returns
 */
export const getPersonalSpaceOpus = (params?: RequestConfig) => {
  return fetch<IResponse<Opus>>('/youyan/project/', {
    method: 'GET',
    params,
  });
};

/**
 * 获取个人空间成片列表
 * @param params
 * @returns
 */
export const getPersonalSpacePieces = (params?: any) => {
  return fetch<IResponse<ChengPianDetail[]>>('/youyan/generate_record_task/', {
    method: 'GET',
    params,
  });
};

/**
 * 获取成片详情
 * @param params
 * @returns
 */
export const getPiecesDetail = (params: {
  task_id: string;
  generate_record_xihe_task_id?: string;
}) => {
  return fetch('/xihe_offline/generate_record_task/detail_by_task_id/', {
    method: 'GET',
    params,
  });
};

// 获取空间里面成片详情信息
export const getSpacePiecesDetail = (params: { id: number }) => {
  return fetch('/xihe_offline/generate_record_task/detail_by_id/', {
    method: 'GET',
    params,
  });
};

/**
 * 更新成片封面
 * @param params
 * @returns
 */
export const setSpacePieces = (data: any) => {
  return fetch('/youyan/generate_record_task/update_cover_url/', {
    method: 'POST',
    body: data,
  });
};

/**
 * 更新成片模板封面
 * @param params
 * @returns
 */
export const setSpaceProject = (data: any) => {
  return fetch('/youyan/project/update_cover_url/', {
    method: 'POST',
    body: data,
  });
};

/**
 * 重命名个人空间作品
 * @param data
 * @returns
 */
export const renamePersonalSpaceForOpus = (data: any) => {
  return fetch('/youyan/project/', {
    method: 'PUT',
    body: data,
  });
};
/**
 * 项目/作品素材重命名/同步至个人空间
 * @param data
 * @returns
 */
export const renamePersonalSpaceMedia = (data: any) => {
  return fetch(
    data.type === RESOURCE_TYPE.MATERIAL ? '/youyan/project_media/' : '/youyan/customer_config/',
    {
      method: 'PUT',
      body: data,
    },
  );
};

/**
 * 个人空间作品创建副本
 * @param data
 * @returns
 */
export const createCopyPersonalSpaceForOpus = (data: { project_ids: string[] }) => {
  return fetch('/youyan/project/duplicate/', {
    method: 'POST',
    body: data,
  });
};

/**
 * 删除个人空间作品
 * @param data
 * @returns
 */
export const deletePersonalSpaceForOpus = (data: { project_ids: string[]; into_room: boolean }) => {
  return fetch('/youyan/project/', {
    method: 'DELETE',
    body: data,
  });
};

/**
 * 个人空间成片重命名
 * @param data
 * @returns
 */
export const renamePersonalSpaceForPieces = (data: any) => {
  return fetch('/youyan/generate_record_task/', {
    method: 'PUT',
    body: data,
  });
};

/**
 * 个人空间成片创建模板
 * @param data
 * @returns
 */
export const createTemplatePersonalSpaceForPieces = (data: any) => {
  return fetch('/youyan/generate_record_task/create_task_template/', {
    method: 'POST',
    body: data,
  });
};

/**
 * 个人空间成片另存为新作品并编辑
 * @param data
 * @returns
 */
export const saveAsPersonalSpaceForPieces = (data: any) => {
  return fetch('/youyan/generate_record_task/edit_task/', {
    method: 'POST',
    body: data,
  });
};

/**
 * 个人空间成片重新导出
 * @param data
 * @returns
 */
export const resynthesis = (data: any, config?: any) => {
  return fetch('/youyan/generate_record_task/retry/', {
    method: 'POST',
    body: data,
    ...(config || {}),
  });
};

/**
 * 个人空间成片取消合成
 * @param data
 * @returns
 */
export const cancelTask = (data: any) => {
  return fetch('/youyan/generate_record_task/cancel/', {
    method: 'POST',
    body: data,
  });
};

/**
 * 个人空间成片删除
 * @param data
 * @returns
 */
export const deletePieces = (data: any) => {
  return fetch('/youyan/generate_record_task/remove/', {
    method: 'POST',
    body: data,
  });
};

/**
 * 个人空间成片加速
 * @param data
 * @returns
 */
export const accelerateTask = (data: any) => {
  return fetch('/youyan/generate_record_task/speed_up/', {
    method: 'POST',
    body: data,
  });
};

/**
 * 获取个人空间成片加速情况
 * @param data
 * @returns
 */
export const getAccelerateTaskPreview = (params: any) => {
  return fetch('/youyan/generate_record_task/speed_up_preview/', {
    method: 'GET',
    params,
  });
};

/**
 * 获取获取当前言币
 * @param data
 * @returns
 */
export const getCurrentYanBi = (params: any) => {
  return fetch('/youyan/project/check_consume/', {
    method: 'GET',
    params,
  });
};

/**
 * 获取个人空间成片当天加速额度
 * @param data
 * @returns
 */
export const getAccelerateTaskCount = () => {
  return fetch('/youyan/generate_record_task/speed_count/', {
    method: 'GET',
  });
};

/**
 * 获取个人空间资源下的素材列表
 * @param data
 * @returns
 */
export const getPersonalSpaceMaterial = (params: any) => {
  return fetch('/youyan/project_media/', {
    method: 'GET',
    params,
  });
};

/**
 * 获取个人空间成片状态列表
 * @param data
 * @returns
 */
export const getPersonalSpaceList = (params: any) => {
  return fetch('/youyan/generate_record_task/processing_task_info/', {
    method: 'GET',
    params,
  });
};

/**
 * 个人空间获取资源(不含素材)
 * @param data
 * @returns
 */
export const getPersonalSpaceOtherResource = (params: any) => {
  return fetch('/youyan/customer_config/', {
    method: 'GET',
    params,
  });
};

/**
 * 编辑器，从素材箱里删除素材
 * @param data
 * @returns
 */
export const deletePersonalSpaceMaterial = (body: any) => {
  return fetch('/youyan/project_media/', {
    method: 'DELETE',
    body,
  });
};

/**
 * 删除个人空间资源
 * @param data
 * @returns
 */
export const deletePersonalSpaceResource = (body: any) => {
  return fetch('/youyan/customer_config/', {
    method: 'DELETE',
    body,
  });
};

/**
 * 从回收站中恢复
 * @param data
 * @returns
 */
export const restoreRecycle = (body: any) => {
  return fetch('/youyan/personal_room_recycle_bin/restore/', {
    method: 'POST',
    body,
  });
};

/**
 * 从回收站彻底删除
 * @param data
 * @returns
 */
export const deleteRecycle = (body: any) => {
  return fetch('/youyan/personal_room_recycle_bin/completely_delete/', {
    method: 'POST',
    body,
  });
};

interface IDelete {
  ids: string[];
}

/**
 * 获取团队空间
 * @param config
 * @returns
 */
export const getTeamSpace = (params: any) => {
  return fetch('/youyan/team_space/', {
    method: 'GET',
    params,
  });
};

/**
 * 获取团队空间回收站
 * @param config
 * @returns
 */
export const getTeamSpaceForRecycle = (params: any) => {
  return fetch('/youyan/team_room_recycle_bin/', {
    method: 'GET',
    params,
  });
};

/**
 * 复制至个人空间
 * @param config
 * @returns
 */
export const copyTeamSpace = (data: any) => {
  return fetch<IResponse>('/youyan/team_space/copy_to_personal/', {
    method: 'POST',
    body: data,
  });
};

/**
 * 更新团队空间
 * @param config
 * @returns
 */
export const updateTeamSpace = (data: any) => {
  return fetch('/youyan/team_space/', {
    method: 'PUT',
    body: data,
  });
};

/**
 * 新建团队空间记录
 * @param config
 * @returns
 */
export const addTeamSpace = (data: any) => {
  return fetch('/youyan/team_space/create_task_template/', {
    method: 'POST',
    body: data,
  });
};

/**
 * 删除团队空间记录
 * @param config
 * @returns
 */
export const deleteTeamSpace = (data: IDelete) => {
  return fetch('/youyan/team_space/remove/', {
    method: 'POST',
    body: data,
  });
};

/**
 * 获取个人空间资源下的素材列表
 * @param data
 * @returns
 */
export const getPersonalSpaceRecycle = (params: any) => {
  return fetch('/youyan/personal_room_recycle_bin/', {
    method: 'GET',
    params,
  });
};

/**
 * 获取与我分享列表
 * @param data
 * @returns
 */
export const getShareList = (params: any) => {
  return fetch('/youyan/my_share/', {
    method: 'GET',
    params,
  });
};

/**
 * 删除与我分享
 * @param data
 * @returns
 */
export const deleteShare = (data: any) => {
  return fetch('/youyan/my_share/remove/', {
    method: 'POST',
    body: data,
  });
};

// 批量删除失效文件
export const postRemoveSourceIsDeleteForSpace = (params: { model_type: number }) => {
  return fetch('/youyan/my_share/remove_source_is_delete/', {
    method: 'POST',
    params,
  });
};

/**
 * 与我分享创建成片模板
 * @param data
 * @returns
 */
export const createShareTemplate = (data: any) => {
  return fetch('/youyan/my_share/create_task_template/', {
    method: 'POST',
    body: data,
  });
};

/**
 * 与我分享复制到个人空间
 * @param data
 * @returns
 */
export const copyToPersonal = (data: any) => {
  return fetch('/youyan/my_share/copy_to_personal/', {
    method: 'POST',
    body: data,
  });
};

/**
 * 与我分享复另存新作品并编辑
 * @param data
 * @returns
 */
export const editAsForShare = (data: any) => {
  return fetch('/youyan/my_share/edit_task/', {
    method: 'POST',
    body: data,
  });
};

/**
 * 从回收站中恢复-团队空间
 * @param data
 * @returns
 */
export const restoreRecycleForTeam = (body: any) => {
  return fetch('/youyan/team_room_recycle_bin/restore', {
    method: 'POST',
    body,
  });
};

/**
 * 从回收站彻底删除-团队空间
 * @param data
 * @returns
 */
export const deleteRecycleForTeam = (body: any) => {
  return fetch('/youyan/team_room_recycle_bin/completely_delete', {
    method: 'POST',
    body,
  });
};
/**
 * 取消品牌规范
 * @param data
 * @returns
 */
export const cancelBrand = (body: any) => {
  return fetch('/brand/change_brand_status/', {
    method: 'PUT',
    body,
  });
};

/**
 * 确认版权
 * @param data
 * @returns
 */
export const updateCopyrightConfirmation = (body: any) => {
  return fetch('/youyan/resource_limit_notice/set_had_read/', {
    method: 'POST',
    body,
  });
};

/**
 * 版权确认
 * @param data
 * @returns
 */
export const getCopyrightConfirmation = (params: any) => {
  return fetch('/youyan/resource_limit_notice/had_read/', {
    method: 'GET',
    params,
  });
};
